import React, {useEffect, useMemo, useState} from 'react';
import {Box, Button, Step, StepLabel, Stepper} from '@mui/material';
import BaseModal from '../../utils/BaseModal';
import {useSelector} from 'react-redux';
import {RootState} from '../../../store';
import SignupEmailVerificationStep from './SignupEmailVerificationStep';
import SignupTradeUrlStep from './SignupTradeUrlStep';
import SignupDownloadExtensionStep from './SignupDownloadExtensionStep';

type SignUpStep =
    | 'EMAIL_VERIFICATION'
    | 'ADD_TRADE_URL'
    | 'DOWNLOAD_EXTENSION';

const steps: SignUpStep[] = [
  'EMAIL_VERIFICATION',
  'ADD_TRADE_URL',
  'DOWNLOAD_EXTENSION'
];

function getStepIndex(step: SignUpStep | null) {
  if (!step) {
    return 0;
  }
  const index = steps.indexOf(step);
  return index === -1 ? 0 : index;
}

const SignupFlowModal: React.FC = () => {

  const signUpStep = useSelector(
      (state: RootState) => state.auth.signUpStep
  );

  const open = signUpStep !== 'NONE' && signUpStep !== 'COMPLETED';

  const initialStep = useMemo(
      () => getStepIndex(signUpStep as SignUpStep),
      [signUpStep]
  );

  const [activeStep, setActiveStep] = useState(initialStep);

  useEffect(() => {
    setActiveStep(initialStep);
  }, [initialStep]);

  return (
      <BaseModal
          open={open}
          title="Complete your signup"
          maxWidth="md"
          minHeight="400px"
          maxHeight="80vh"
      >
        <Stepper
            activeStep={activeStep}
            alternativeLabel
        >
          <Step>
            <StepLabel>Email verification</StepLabel>
          </Step>
          <Step>
            <StepLabel>Add Trade-URL</StepLabel>
          </Step>
          <Step>
            <StepLabel>Download extension</StepLabel>
          </Step>
        </Stepper>

        <Box className="mt-6">
          {steps[activeStep] === 'EMAIL_VERIFICATION' && (
              <SignupEmailVerificationStep />
          )}

          {steps[activeStep] === 'ADD_TRADE_URL' && (
              <SignupTradeUrlStep />
          )}

          {steps[activeStep] === 'DOWNLOAD_EXTENSION' && (
              <SignupDownloadExtensionStep />
          )}
        </Box>
      </BaseModal>
  );
};

export default SignupFlowModal;